import { CustomTable } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';
import { EventMachineSaleProductReport } from '@/model/EventMachineSaleProductReport';
import React, { Fragment } from 'react';
import SuperCollapse from '@/components/sharedComponents/SuperCollapse';
import { ReportDropdownHeader } from '../../ReportDropdownHeader';

interface StateProps {
  machines: EventMachineSaleProductReport[];
}

export const SaleProductMachineContent: React.FC<StateProps> = ({ machines }): JSX.Element => (
  <Fragment>
    {machines.map(data => (
      <div key={data.id} className="mb-3">
        <SuperCollapse
          title={
            <ReportDropdownHeader
              title={`POS: ${data.serialNumber}`}
              summary={data.summary}
              payments={data.payments}
            />
          }
          content={
            <div className="p-3 bg-white rounded">
              {data.categories.map(category => (
                <div key={category.id} className="mb-4">
                  <h6 className="font-weight-bold mb-2 text-secondary">{category.name}</h6>
                  <CustomTable
                    theme="secondaryWithoutBorder"
                    numberRowsPerPage={0}
                    progressPending={false}
                    columns={[
                      {
                        name: 'Produto',
                        selector: row => row.productName,
                      },
                      {
                        name: 'Vendidos',
                        selector: row => row.productSold,
                      },
                      {
                        name: 'Valor',
                        selector: row => row.unitValue,
                      },
                      {
                        name: 'Venda',
                        selector: row => row.totalSaleValue,
                      },
                      {
                        name: 'Comissão',
                        selector: row => row.totalCommission,
                      },
                      {
                        name: 'Venda + Comissão',
                        selector: row => row.totalSaleWithCommission,
                      },
                    ]}
                    data={
                      category.products.map(product => ({
                        productName: product.name,
                        productSold: product.amountSold,
                        unitValue: toCurrency(product.unitValue),
                        totalSaleValue: toCurrency(product.totalSaleValue),
                        totalCommission: toCurrency(product.totalCommission),
                        totalSaleWithCommission: toCurrency(product.totalSaleWithCommission),
                      })) || []
                    }
                  />
                </div>
              ))}
            </div>
          }
        />
      </div>
    ))}
  </Fragment>
);
